<template>
  <div class="vocation-concat">
    <div class="inner">
      <div class="en">{{ dataInfo.tips }}</div>
      <div class="inner-ri">
        <div class="zh">{{ dataInfo.name }}.</div>
        <img
          @click="toConcat"
          class="img"
          src="../../../assets/img/concat-us.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {}
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);

    this.dataInfo = dataInfo;
  },
  methods: {
    toConcat() {
      this.$router.push({
        path: "/concact_us",
        query: {
          id: this.menuId
        }
      });
    }
  }
};
</script>
<style lang="less">
.vocation-concat {
  display: flex;
  align-items: center;
  height: 220px;
  background: #2c6fff;
  box-sizing: border-box;
  padding-left: 2.6%;
  padding-right: 13.75%;
  .inner {
    display: flex;
    align-items: center;
    width: 100%;
    .en {
      margin-right: 48px;
      // max-width: 360px;
      white-space: nowrap;
      font-size: 130px;
      font-family: "en-tit";
      color: rgba(255, 255, 255, 0);
      line-height: 163px;
      -webkit-text-stroke: 1px #fff;
      overflow: hidden;
      width: 320px;
      text-stroke: 1px #fff;
    }
    &-ri {
      display: flex;
      justify-content: space-between;
      flex-grow: 1;
      .zh {
        padding-right: 48px;
        font-size: 100px;
        font-family: Dream-LiHeiGB, Dream;
        color: #fff;
        line-height: 119px;
      }
      .img {
        display: block;
        width: 138px;
        height: 100px;
        cursor: pointer;
      }
    }
  }
}
</style>
